import { useEffect, useRef } from 'react';

// Calls `refresh` when the user comes back to the tab after more than `minMs`. There is deliberately NO background
// polling: every protected call moves the idle expiry of the verification, so a timer would keep the module unlocked.
export function useRefreshOnReturn(refresh, minMs = 60_000) {
  const refreshRef = useRef(refresh);
  const lastRef = useRef(0);

  useEffect(() => {
    refreshRef.current = refresh;
  });

  useEffect(() => {
    lastRef.current = Date.now();
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return;
      if (Date.now() - lastRef.current < minMs) return;
      lastRef.current = Date.now();
      refreshRef.current();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, [minMs]);
}
